import { RestRequestBuilder } from "@frui.ts/apiclient";
import AuthorizationService from "../services/authorizationService";
import EventBus, { serverError, userLogout } from "../services/eventBus";

export default abstract class RepositoryBase<TRequestBuilder = RestRequestBuilder> {
  constructor(
    protected apiFactory: () => TRequestBuilder,
    protected authorizationService: AuthorizationService,
    protected eventBus: EventBus
  ) {}

  protected async callApi<T>(action: (api: TRequestBuilder) => Promise<T>, useGenericErrorMessageHandler = true) {
    if (!this.authorizationService.isAuthorized()) {
      await this.authorizationService.authorize();
    } else {
      await this.authorizationService.startAccessTokenRenewCycle();
    }

    const promise = action(this.apiFactory());

    promise.catch(error => {
      if (error.response?.status === 401) {
        this.eventBus.publish(userLogout());
      }

      if (!useGenericErrorMessageHandler) {
        return error;
      }

      const status = error.response?.status;
      if (status && status >= 500) {
        this.eventBus.publish(serverError({ type: "internalServerError" }));
      } else {
        this.eventBus.publish(serverError({}));
      }
    });

    return promise;
  }
}
